"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireDefault(require("react"));
var _select = _interopRequireDefault(require("./select"));
var _selectOptions = require("./select-options");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SelectCode(props) {
  const _getOptions = () => {
    if (!props.isLoaded) return [];
    return (0, _selectOptions.selectOptions)(props);
  };

  // bibs require classDivisionID which, in turn require classRef
  // passing the options as an empty array and the other props
  // (to include onChange and value) forces them to reset to null when higher level
  // field is cleared.

  return /*#__PURE__*/_react.default.createElement("span", null, props.lookup === 'ClassDivisions' && !props.classRef ? /*#__PURE__*/_react.default.createElement(_select.default, _extends({}, props, {
    options: [],
    disabled: true,
    placeholder: "Select a class first"
  })) : (props.lookup === 'BibNumbers' || props.lookup === 'PaddlersByBib') && !props.classDivisionID ? /*#__PURE__*/_react.default.createElement(_select.default, _extends({}, props, {
    options: [],
    disabled: true,
    placeholder: "Select a class and division first"
  })) : props.lookup === 'CompetitionDays' && !props.competitionID ? /*#__PURE__*/_react.default.createElement(_select.default, _extends({}, props, {
    options: [],
    disabled: true
  })) : /*#__PURE__*/_react.default.createElement(_select.default, _extends({}, props, {
    options: _getOptions(),
    isLoading: !props.loaded
  })));
}

// *************************************************************
// Data
// *************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(SelectCode, props => (0, _selectOptions.selectQuery)(props), undefined, {
  renderLoading: true
});